/**
 * 📦 V2 Physical Products API client
 * Rotas /api/v2/physical-products
 */

import v2Api from './index';

export const physicalProductsV2API = {
  /**
   * Cria um produto físico.
   * Body: { product_id, name, price_cents, product_type,
   *         width_cm?, length_cm?, height_cm?, weight_grams?,
   *         sku?, is_sellable_alone?, display_order?,
   *         download_url?, ncm?, cfop?, cst? }
   * R1.6: máximo 4 por produto. PRD-01: largura/comprimento >= 2cm.
   */
  create: (data) => v2Api.post('/physical-products', data),

  /**
   * Lista produtos físicos de um produto pai.
   */
  listByProduct: (productId) => v2Api.get(`/physical-products/by-product/${productId}`),

  findById: (id) => v2Api.get(`/physical-products/${id}`),

  update: (id, data) => v2Api.patch(`/physical-products/${id}`, data),

  remove: (id) => v2Api.delete(`/physical-products/${id}`),
};

export default physicalProductsV2API;
